
import { createSlice } from "@reduxjs/toolkit";
import { GetSubscriptions } from "./_paymentAction";

const initialState: any = {
    subscriptions: [],
    totalRecord: 0,
    loading: false,
    openCreateSubscriptionPlanModal: false,
    selectedSubscription: null,
};

export const subscriptionActions = createSlice({
    name: "subscriptionActions",
    initialState: initialState,
    reducers: {
    

        setOpenCreateSubscriptionPlanModal: (state) => {
            state.openCreateSubscriptionPlanModal = true
        },
        setCloseCreateSubscriptionPlanModal: (state) => {
            state.openCreateSubscriptionPlanModal = false
        },

        setSelectedSubscription: (state,{payload}) => {
            state.selectedSubscription = payload;
        }
    }
});

export const getSubscriptions = createSlice({
    name: "getSubscriptions",
    initialState: initialState,
    reducers: {
       
        setNewlyAddedTerm: (state, { payload }) => {
            state.subscriptions = [...state.subscriptions, payload]
        },

        updateTerm: (state, { payload }) => {
            let data = payload
            let subscriptions = [...state.subscriptions];
            let index =  subscriptions.findIndex((e:any)=> e._id === data._id);
            if(index !== -1) subscriptions[index] = data;
            state.subscriptions = subscriptions;
            state.totalRecord = payload?.totalRecord;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(GetSubscriptions.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetSubscriptions.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.subscriptions = payload?.data || [];
                state.totalRecord = payload?.totalRecord;
            })
            .addCase(GetSubscriptions.rejected, (state, { payload }) => {
                state.loading = false;

            })
    },
});

export const {setCloseCreateSubscriptionPlanModal,setOpenCreateSubscriptionPlanModal ,setSelectedSubscription} = subscriptionActions.actions;

export const {setNewlyAddedTerm,updateTerm}  = getSubscriptions.actions